import { useState } from "react";
import type { SearchHit } from "@saucer/core";
import { search } from "../api.js";

/**
 * Searches by meaning rather than filename, because the thing people remember
 * about a screenshot is what was in it.
 */
export function SearchBox({ onResults }: { onResults: (hits: SearchHit[] | null) => void }) {
  const [query, setQuery] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (text: string) => {
    if (!text.trim()) {
      onResults(null);
      return;
    }
    setBusy(true);
    try {
      onResults(await search(text));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form
      className="row"
      onSubmit={(event) => {
        event.preventDefault();
        void run(query);
      }}
    >
      <input
        className="input"
        value={query}
        onChange={(event) => {
          setQuery(event.target.value);
          if (event.target.value === "") onResults(null);
        }}
        placeholder="Search your files by what is in them"
        type="search"
      />
      <button className="button" type="submit" disabled={busy}>
        {busy ? "Searching…" : "Search"}
      </button>
    </form>
  );
}
